import React from "react";
import { Message, Style } from "./assets/style";
import { ErrorIcon, InfoIcon, WarningIcon, SuccessIcon } from "./assets/icon";
import { platformNames } from "constants/index";


enum MESSAGE_TYPE {
  INFO = "info",
  WARNING = "warn",
  ERROR = "error",
  SUCCESS = "success",
};


const messageIcon = (type: string) => {
  switch (type) {
    case MESSAGE_TYPE.INFO:
        return <InfoIcon />;
    case MESSAGE_TYPE.WARNING:
        return <WarningIcon />;
    case MESSAGE_TYPE.SUCCESS:
        return <SuccessIcon />;
    case MESSAGE_TYPE.ERROR:
        return <ErrorIcon />;
    default:
      return <InfoIcon />;
  }
};

const messageCardType = (type: string) => {
  switch (type) {
    case MESSAGE_TYPE.INFO:
        return "info-card";
    case MESSAGE_TYPE.WARNING:
        return "warn-card";
    case MESSAGE_TYPE.SUCCESS:
        return "success-card";
    case MESSAGE_TYPE.ERROR:
        return "error-card";
    default:
      return "info-card";
  }
};


export const MsgCard = (MsgCardProps: { message: string, msgIcon?: any, extraClass: string, type: string, boldMessage?: string, dataTestId?: string, platform: string }) => {
  const { message, msgIcon, extraClass, type, boldMessage, dataTestId, platform } = MsgCardProps;

  const msgType = messageCardType(type);
  if (message && type) {
    return (
      <div data-testid={dataTestId}>
        <Style className={`layout horizontal p12 mrl15 ${msgType} ${extraClass}`}>
          {/* Todo: Siddharth: Discuss this */}
          {platform !== platformNames.NIKE && <span className="icon layout horizontal center-center">{msgIcon ? msgIcon() : messageIcon(type)}</span>}
          <Message className={`flex-1 center ${boldMessage ? "d-inline-block" : "layout horizontal"}`}>
            {message}
            {
            boldMessage && (
              <strong>&nbsp;{boldMessage}</strong>
            )
          }
          </Message>
        </Style>
      </div>
    );
  }
  return <div></div>;
};
